import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { IoIosClose } from 'react-icons/io'
import { colors, breakpoints } from 'utils/utils'

export default props => {

    const [closeClass, setCloseClass] = useState('');

    useEffect(() => {
        if(props.closeButton) {
            const type = props.closeButtonType
            switch(type) {
                case 'mobile':
                case 'desktop':
                    setCloseClass(type)
                    break
                default:
                    setCloseClass("all")
                    break
            }
        }
    }, [props])

    return (
        <>
            <PopUpOverley onClick={() => props.close()}/>
            <PopUpContent>
                {
                    props.closeButton && props.closeButton === 'true' &&
                    <Close onClick={() => props.close()} className={closeClass}>
                        <IoIosClose />
                    </Close>
                }
                {props.children}
            </PopUpContent>
        </>
    )
}

const PopUpOverley = styled.button`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: fill-available;
    border: none;
    background-color: rgba(0,0,0,0.5);
    z-index: 1500;
`

const PopUpContent = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    width: auto;
    height: auto;
    transform: translate(-50%, -50%);
    padding: 2rem;
    z-index: 1510;
    ${breakpoints.sm} {
        width: 100vw;
        height: 100vh;
        height: fill-available;
        padding: 0;
    }
`

const Close = styled.button`
    cursor: pointer;
    position: absolute;
    top: 3rem;
    right: 3rem;
    background-color: transparent;
    border: 0;
    box-sizing: border-box;
    z-index: 1520;

    ${breakpoints.md} {
        top: 1.5rem;
        right: 1.5rem;
    }

    &.desktop {
        display: block;
        ${breakpoints.md} {
            display: none;
        }
    }

    &.mobile {
        display: none;
        ${breakpoints.md} {
            display: block;
        }
    }

    svg {
        width: 3rem;
        height: 3rem;
        color: ${colors.quaternary};
    }
`